
















import Vue from 'vue'
import UserAvatar from '@/components/UserAvatar.vue'

export default Vue.extend({
  name: 'AdminContainer',
  components: { UserAvatar },
  computed: {
    activePage() {
      return this.$router.currentRoute.path.split('/').splice(-1)[0]
    }
  }
})
